import { AxiosPromise } from "axios";
import { accountApiConfig, ops } from "./config";
import {
  BrandDto,
  BrandsResourceApi,
  BrandLogoDto,
  BrandBackgroundImageDto,
} from "../generated/account-client";

const api = new BrandsResourceApi(accountApiConfig);

const BrandsApi = {
  getBrand(id: string): AxiosPromise<BrandDto> {
    return api.getBrand(id, ops());
  },
  getBrandPerLocation(id: number): AxiosPromise<BrandDto> {
    return api.getBrandPerLocation(id, ops());
  },
  createBrand(dto: BrandDto): AxiosPromise<BrandDto> {
    return api.createBrand(dto, ops());
  },
  updateBrand(dto: BrandDto): AxiosPromise<BrandDto> {
    return api.updateBrand(dto, ops());
  },
  deleteBrand(id: string): AxiosPromise<void> {
    return api.deleteBrand(id, ops());
  },
  uploadLogo(id: string, image: any): AxiosPromise<BrandLogoDto> {
    return api.uploadLogo(id, image, ops());
  },
  uploadBackgroundImage(
    id: string,
    image: any
  ): AxiosPromise<BrandBackgroundImageDto> {
    return api.uploadBackgroundImage(id, image, ops());
  },
  updateBrandLogos(brandId: string, logoId: string): AxiosPromise<void> {
    return api.updateBrandLogos(brandId, logoId, ops());
  },
};

export default BrandsApi;
